import React from 'react'

// Étiquette de l'étape AC10 : étape, acteur, délai (maquette 0.4)
const SavAc10 = ({etape, acteur, delai}: {etape: string; acteur: string; delai: string}) => (
  <span className='badge badge-light-info fw-semibold'>
    AC10 · {etape} · {acteur} · {delai}
  </span>
)

export default SavAc10
